import script from "./StockWithdraw.vue?vue&type=script&setup=true&lang=ts"
export * from "./StockWithdraw.vue?vue&type=script&setup=true&lang=ts"

import "./StockWithdraw.vue?vue&type=style&index=0&id=31b20e94&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31b20e94"]])

export default __exports__